import react_nat from "../assets/react_native_logo_grey.png";
import node from "../assets/nodejs_logo_grey.png";
// import logo from "../assets/logo.png";
import gcloud from "../assets/google_cloud_logo_grey.png";
import html from "../assets/html_logo_grey.png";

export const Logos = () => {
  return (
    <>
      <div className="limiter logos_badge">
        {[
          { src: node, width: "120px", height: "auto" },
          { src: html, width: "34px", height: "auto" },
          { src: react_nat, width: "120px", height: "auto" },
          { src: gcloud, width: "140px", height: "auto" },
        ].map((i) => {
          return (
            <>
              <img src={i.src} width={i.width} height={i.height} />
              <div style={{ minWidth: 70, width: 120, height: 40 }} />
            </>
          );
        })}
      </div>
    </>
  );
};
